export default __webpack_public_path__ + "1e0d31aa0c656696989a2ff6d7e5d3f2.svg";